import StudentTableDialog from "./StudentTableDialog";
export default StudentTableDialog;
